/*
    Page: login page navigated by React Router
 */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import auth from '../modules/Auth0_setup';
import '../css/login-page.css';
import 'react-bootstrap';
import { reCaptchaSiteKey } from "../modules/configs";
import ReCaptcha from 'react-google-recaptcha';

export const Operations = {
    LOGIN: 'login',
    SIGNUP: 'signup',
    RESET_PWD: 'resetPwd',
    PRINT_DATA_LOGIN: 'printDataLogin',
    PRINT_RECORD_LOGIN: 'cstLogin'
}

export default class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.reCaptchaInstance = React.createRef();
        this.usernameInstance = React.createRef();
        this.passwordInstance = React.createRef();
        this.initState = {
            username: '',
            password: '',
            reEnteredPassword: '',
            errorMessage: '',
            infoMessage: '',
            isAuthenticated: false,
            isFormSubmitted: false,
            operation: props.match.params.operation,
            reCaptchaCode: ''
        };
        this.state = this.initState;
        this.resetState = this.resetState.bind(this);
        this.login = this.login.bind(this);
        this.signup = this.signup.bind(this);
        this.resetPwd = this.resetPwd.bind(this);
        console.log("Login Operation: " + this.state.operation)
    }

    componentDidMount() {
        if (!auth.isAuthenticated()) {
            console.log("LoginPage.componentDidMount - auth is not authenticated, logout");
            auth.logout();
            if ( this.props.location.state && this.props.location.state.errorMessage) {
                this.errorMessage(this.props.location.state.errorMessage)
            }
        }
    }

    render() {
        const { operation } = this.state;
        if (auth.isAuthenticated()) {
            if (operation === Operations.PRINT_DATA_LOGIN) {
                return <Redirect to={'/printData'}/>
            }
            if (operation === Operations.PRINT_RECORD_LOGIN) {
                return <Redirect to={'/customerSupportAnaylitics'}/>
            }
            if (this.props.location.state && this.props.location.state.showAccountPage) {
                return <Redirect to='/account'/>
            }
            console.log("LoginPage.render - already authenticated, redirect to main page");
            return <Redirect to='/'/>
        }
        return <div className='login-page-wrapper'>
            <div className="login-page">
                <div className="form">
                    <div className='sprintray-icon'><img src='https://sprintray.com/oracle/uploads/2019/04/SprintRayLogo-black.png'/></div>
                    <h4 className='subtitle'>Print Dashboard</h4>
                    {
                        this.state.errorMessage &&
                            <div className='error-message-box alert alert-danger'>
                                <strong>Error: </strong>{this.state.errorMessage}
                            </div>
                    }
                    {
                        this.state.infoMessage &&
                            <div className='info-message-box alert alert-info'>
                                {this.state.infoMessage}
                            </div>
                    }

                    { operation === Operations.SIGNUP &&
                        this.RegisterForm()
                    }

                    { operation === Operations.LOGIN &&
                        this.LoginForm()
                    }

                    { operation === Operations.RESET_PWD &&
                        this.ResetPasswordForm()
                    }

                    {operation === Operations.PRINT_DATA_LOGIN &&
                        this.PrintDataLoginForm()
                    }

                    { operation === Operations.PRINT_RECORD_LOGIN &&
                        this.PrintRecordLoginForm()
                    }

                    <div className='recaptcha-wrapper'>
                        <ReCaptcha
                            ref={this.reCaptchaInstance}
                            sitekey={reCaptchaSiteKey}
                            size='invisible'
                            onChange={this.onReCaptchaVerified.bind(this)}
                        />
                    </div>
                </div>
            </div>
        </div>
    }

    LoginForm() {
        return (
            <form className="login-form">
                <input type="text" placeholder="Email/Username"
                       value={this.state.username}
                       onChange={(ev) => this.setState({username: ev.target.value})}
                       ref={node => this.usernameInstance = node}
                />
                <input type="password" placeholder="Password"
                       value={this.state.password}
                       onChange={(ev) => this.setState({password: ev.target.value})}
                       ref={node => this.passwordInstance = node}
                />
                <button onClick={(ev) => this.submitForCaptcha(ev)} disabled={this.state.isFormSubmitted}>
                    {this.state.isFormSubmitted ? 'Logging in...' : 'Login'}
                </button>
                <p className="message">
                    Not registered? <a href={`/${Operations.SIGNUP}`}>Create an account</a>
                </p>
                <p className="message">
                    Forget your password? <a href={`/${Operations.RESET_PWD}`} className="reset-switch">Reset password</a>
                </p>
            </form>
        )
    }

    PrintDataLoginForm() {
        return (
            <form className="login-form">
                <div className='error-message-box alert alert-warning'>
                    <strong>Notice: </strong>This is an internal login page, please do not share it with external！
                </div>
                <input type="text" placeholder="Email/Username"
                       value={this.state.username}
                       onChange={(ev) => this.setState({ username: ev.target.value })}
                       ref={node => this.usernameInstance = node}
                />
                <input type="password" placeholder="Password"
                       value={this.state.password}
                       onChange={(ev) => this.setState({ password: ev.target.value })}
                       ref={node => this.passwordInstance = node}
                />
                <button onClick={(ev) => this.submitForCaptcha(ev)} disabled={this.state.isFormSubmitted}>
                    {this.state.isFormSubmitted ? 'Logging in...' : 'Print Data Login'}
                </button>
                <p className="message"><a href={`/${Operations.LOGIN}`}>Back to Dashboard</a></p>
            </form>
        )
    }

    PrintRecordLoginForm() {
        return (
            <form className="login-form">
                <div className='error-message-box alert alert-warning'>
                    <strong>Notice: </strong>This is an internal login page, please do not share it with external！
                </div>
                <input type="text" placeholder="Email/Username"
                    value={this.state.username}
                    onChange={(ev) => this.setState({ username: ev.target.value })}
                    ref={node => this.usernameInstance = node}
                />
                <input type="password" placeholder="Password"
                    value={this.state.password}
                    onChange={(ev) => this.setState({ password: ev.target.value })}
                    ref={node => this.passwordInstance = node}
                />
                <button onClick={(ev) => this.submitForCaptcha(ev)} disabled={this.state.isFormSubmitted}>
                    {this.state.isFormSubmitted ? 'Logging in...' : 'Customer Service Login'}
                </button>
                <p className="message"><a href={`/${Operations.LOGIN}`}>Back to Dashboard</a></p>
            </form>
        )
    }

    ResetPasswordForm() {
        return (
            <form className="reset-form">
            <input type="text" placeholder="Email/Username"
                   value={this.state.username}
                   onChange={(ev) => this.setState({username: ev.target.value})}/>
            <button onClick={(ev) => this.submitForCaptcha(ev)} disabled={this.state.isFormSubmitted}>
                {this.state.infoMessage ? 'Sent' : 'Send reset email'}
            </button>
            <p className="message">
                Go back to login? <a href={`/${Operations.LOGIN}`} className="reset-switch">Click here</a>
            </p>
        </form>
        )
    }

    RegisterForm() {
        return (
            <form className="register-form">
                <input type="text" placeholder="Email Address"
                       value={this.state.username}
                       onChange={(ev) => this.setState({username: ev.target.value})}/>
                <input type="password" placeholder="Password"
                       value={this.state.password}
                       onChange={(ev) => this.setState({password: ev.target.value})}/>
                <input type="password" placeholder="Re-Enter Password"
                       value={this.state.reEnteredPassword}
                       onChange={(ev) => this.setState({reEnteredPassword: ev.target.value})}/>
                <button onClick={(ev) => this.submitForCaptcha(ev)} disabled={this.state.isFormSubmitted}>SignUp
                </button>
                <p className="message">Already registered? <a href={`/${Operations.LOGIN}`}>Sign In</a></p>
            </form>
        )
    }

    resetState(curOperation) {
        this.setState(this.initState);
        if (curOperation) {
            this.setState({operation: curOperation});
        }
    }

    submitForCaptcha(ev) {
        console.log('Executing ReCaptcha check...');
        this.setState({ isFormSubmitted: true, errorMessage: '' });
        if (ev) ev.preventDefault();
        this.reCaptchaInstance.current.reset();

        this.reCaptchaInstance.current.execute();
    }

    async onReCaptchaVerified(response) {
        console.log(`verified response: ${response}`);
        this.setState({reCaptchaCode: response});
        const {operation} = this.state;

        if (operation === Operations.LOGIN || operation === Operations.PRINT_DATA_LOGIN || operation === Operations.PRINT_RECORD_LOGIN) {
            await this.login();
        }
        else if (operation === Operations.SIGNUP) {
            await this.signup();
        }
        else if (operation === Operations.RESET_PWD) {
            await this.resetPwd();
        }
    }

    async login(ev) {
        if (ev) ev.preventDefault();
        const {username, password, reCaptchaCode} = this.state;

        if (!username)
            return this.errorMessage('Username should not be empty.');
        if (!password)
            return this.errorMessage('Password should not be empty.');
        if (!reCaptchaCode)
            return this.errorMessage('ReCaptcha verification failed. Please try again.');

        /* Fixes for auto-fill bug on Chrome */
        if (this.usernameInstance.value !== this.state.username) {
            this.setState({username: this.usernameInstance.value});
        }
        if (this.passwordInstance.value !== this.state.password) {
            this.setState({password: this.passwordInstance.value});
        }

        const loginError = await auth.login(username, password, reCaptchaCode);
        if (loginError) {
            this.setState({errorMessage: loginError.data.error, isFormSubmitted: false});
        }
        else {
            this.setState({isAuthenticated: true});
        }
    }

    async signup(ev) {
        if (ev) ev.preventDefault();
        const {username, reEnteredPassword, password, reCaptchaCode} = this.state;

        if (!username)
            return this.errorMessage('Email should not be empty.');
        if (!password)
            return this.errorMessage('Password should not be empty.')
        if (reEnteredPassword !== password)
            return this.errorMessage('Password doesn\'t match.');
        if (!reCaptchaCode)
            return this.errorMessage('ReCaptcha verification failed. Please try again.');

        const doesPasswordFollowPolicy = this.checkPasswordPolicy(password)
        if (!doesPasswordFollowPolicy) return;

        const signupError = await auth.signup(username, password, reCaptchaCode);
        if (signupError) {
            this.errorMessage(signupError);
        }
        else {
            await this.login();
        }
    }

    checkPasswordPolicy(password) {
        const passwordRegex = /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/;
        const PasswordPolicyFailureMessage = () =>
            <div>
                <strong>Password Must Contain</strong>
                <ul>
                    <li>8 characters in length</li>
                    <li>Lower case letters (a-z)</li>
                    <li>Upper case letters (A-Z)</li>
                    <li>Numbers (i.e. 0-9)</li>
                </ul>
            </div>

        if (!passwordRegex.test(password) || password.length < 8) {
            this.errorMessage(<PasswordPolicyFailureMessage/>)
            return false;
        }

        return true;
    }

    async resetPwd(ev) {
        if (ev) ev.preventDefault();
        const {username, reCaptchaCode} = this.state;
        if (!username)
            return this.errorMessage('Email address should not be empty.');
        if (!reCaptchaCode)
            return this.errorMessage('ReCaptcha verification failed. Please try again.');

        const response = await auth.sendPasswordChangingEmail(username, reCaptchaCode);
        this.infoMessage(response);
    }

    errorMessage(msg) {
        this.setState({errorMessage: msg, infoMessage: '', isFormSubmitted: false});
    }

    infoMessage(msg) {
        this.setState({infoMessage: msg, errorMessage: ''});
    }
}



// WEBPACK FOOTER //
// ./src/components/login_page.js